import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';
import SectionContainer from 'components/Containers/SectionContainer';
import { getRatingRanges } from 'helpers/calculations';
import { ConditionalRendering } from 'helpers/conditionalRedering.helper';
import ArtScoreUpStar from 'style/_assets/notificationsAlerts/art-score-up-star.png';
import ScoreBandChange from './components/ScoreBandChange';
import ActionYouCanTakeWrapper from './components/ActionYouCanTakeWrapper';
import FrequentlyAskedQuestionsWrapper from './components/FrequentlyAskedQuestionsWrapper';
import OText from 'components/CText/OText';
import { Image } from 'components/Image/Image';

const AccountChangeScoreBrandNotification = props => {
  const { selectedAlertDetails } = props;

  const currentScoreBand =
    selectedAlertDetails?.alertDetails?.scoreBandInfo?.current;
  const previousScoreBand =
    selectedAlertDetails?.alertDetails?.scoreBandInfo?.previous;
  const currentRangesRating = getRatingRanges(currentScoreBand?.scoreBand);
  const isScoreBandImproved =
    previousScoreBand.creditScore <= currentScoreBand.creditScore;

  const title =
    props?.config?.notificationAlerts?.accountChangeScoreBand?.title;
  let subTitle =
    props?.config?.notificationAlerts?.accountChangeScoreBand?.subTitle;
  if (subTitle?.includes('#currentScoreBandCreditScore') && subTitle?.replace) {
    subTitle = subTitle?.replace(
      '#currentScoreBandCreditScore',
      currentScoreBand?.creditScore,
    );
  }
  if (subTitle?.includes('#currentScoreBand') && subTitle?.replace) {
    subTitle = subTitle?.replace(
      '#currentScoreBand',
      currentScoreBand?.scoreBand,
    );
  }
  if (subTitle?.includes('#currentRangesRatingMinMax') && subTitle?.replace) {
    subTitle = subTitle?.replace(
      '#currentRangesRatingMinMax',
      `${currentRangesRating.min}-${currentRangesRating.max}`,
    );
  }
  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label type="H4" typeHeader={'h4'}>
          {title}
        </Label>
      </Row>

      <Row>
        <FlexContainer column>
          <Label className="caption fontGray300">
            {`Reported on ${props.alertDetailsConfig?.date} to `}
            {
              props?.bureauLogo[
                props.selectedAlertDetails?.bureau ||
                  props.selectedAlertDetails?.alertProvider
              ]
            }
          </Label>
          <div>
            <ConditionalRendering isTrue={!isScoreBandImproved}>
              <Label className="margT16">
                <Image imgClass="artScoreDown" />
              </Label>
            </ConditionalRendering>
            <ConditionalRendering isTrue={isScoreBandImproved}>
              <img src={ArtScoreUpStar} alt="Score Up" />
            </ConditionalRendering>
          </div>

          <Label className="text-16 bold  margt20">
            Your score moved from {previousScoreBand?.scoreBand} to{' '}
            {currentScoreBand?.scoreBand}
          </Label>
          <ConditionalRendering
            isTrue={
              previousScoreBand.creditScore > currentScoreBand.creditScore
            }
          >
            <Label type="Body1" className="margT16 mBody-2">
              <OText text={subTitle} />
            </Label>
          </ConditionalRendering>
          <ConditionalRendering
            isTrue={
              previousScoreBand.creditScore <= currentScoreBand.creditScore
            }
          >
            <Label type="Body1" className="margT16 mBody-2">
              Your score is now {currentScoreBand?.creditScore}. This is a{' '}
              <strong>{currentScoreBand?.scoreBand}</strong> credit score in the
              band {currentRangesRating.min}-{currentRangesRating.max}. Rising
              to this score band may help you achieve more financial freedom.
            </Label>
          </ConditionalRendering>

          <div className="margt16">
            <Label type="H5" typeHeader={'h5'} className="bold margb16">
              What Changed?
            </Label>
            <ScoreBandChange
              tradelines={
                props?.selectedAlertDetails?.alertDetails?.scoreBandInfo
              }
            />
          </div>
        </FlexContainer>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row>
        <ActionYouCanTakeWrapper
          isScoreBandImproved={isScoreBandImproved}
          config={props?.config}
          {...props}
        />
      </Row>
      <div className="padTB4 bgGrey005"></div>
      {props?.config?.notificationAlerts?.accountChangeScoreBand
        ?.showPhxAccountScoreChangeDisclaimer && (
        <Row>
          <Label type="Body1" className="italic">
            This information is for educational purposes only and may not be
            accurate or complete. We are not a credit repair organization,
            counselor, or advisor. For financial, credit, tax, or legal advice,
            consult a professional advisor.
          </Label>
        </Row>
      )}
      <Row className="padt20">
        <FrequentlyAskedQuestionsWrapper
          isScoreBandImproved={isScoreBandImproved}
          config={props?.config}
        />
      </Row>
    </SectionContainer>
  );
};

export default AccountChangeScoreBrandNotification;
